import axios from "@/libs/api.request";

export const getCost = params => {
  return axios.request({
    url: "/extract/cost",
    method: "get",
    params
  });
};

export const updateShareSave = data => {
  return axios.request({
    url: `/extract/agent/shareSave`,
    method: "post",
    data
  });
};

export const getAgentShare = params => {
  return axios.request({
    url: "/extract/agent/share",
    method: "get",
    params
  });
};

export const add = data => {
  return axios.request({
    url: "/extract/cost",
    method: "post",
    data
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/extract/cost/${id}`,
    method: "get"
  });
};

export const update = data => {
  return axios.request({
    url: `/extract/cost/${data.id}`,
    method: "put",
    data
  });
};

export const del = id => {
  return axios.request({
    url: `/extract/cost/${id}`,
    method: "delete"
  });
};

export const getCostItem = () => {
  return axios.request({
    url: "/common/cost_item",
    method: "get"
  });
};

export const getDeliverAddress = () => {
  return axios.request({
    url: "/common/deliver_address",
    method: "get"
  });
};

export const getShareType = () => {
  return axios.request({
    url: "/common/share_type",
    method: "get"
  });
};
